import { createApi } from '@/api'
export default {
	getRoleList: config => createApi( `/role/pageSearch`, 'post', config ),
	roleDetail: config => createApi(`/role/getRolePermissions`, 'get', config),
	addrole: config => createApi(`/role/add`, 'post', config),
	deleterole: config => createApi(`/role/delete`, 'delete', config),
	updaterole: config => createApi(`/role/update`, 'post', config)
}



// WEBPACK FOOTER //
// ./src/views/roleManage/api/index.js